import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from '../services/api.service';
import { AppService } from '../services/app.service';
import { Subscription } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { BannerComponent } from '../components/banner/banner.component';

@Component({
    selector: 'app-confirmation',
    imports: [TranslatePipe, BannerComponent],
    templateUrl: './confirmation.component.html',
    styleUrl: './confirmation.component.scss'
})
export class ConfirmationComponent implements OnInit, OnDestroy {

  private $appData: Subscription;
  data: any = {};
  today = new Date();

  constructor(private apiService: ApiService, private appService: AppService) {
    this.$appData = this.apiService.$appData.subscribe(data => { this.applyValues(data); });
  }

  ngOnInit(): void {
    const data = this.apiService.getData();
    this.applyValues(data);
    document.getElementById('confirm-header')?.focus()
  }

  ngOnDestroy(): void {
    this.$appData.unsubscribe();
  }

  applyValues(res: any) {
    this.data = res;
    this.appService.addClickEvent()
  }
  
}
